






import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class VIconPrev extends Vue {
  @Prop() alt?: string;
  @Prop({ default: () => false }) disabled?: boolean;

  get classCss(): string {
    return "icon-prev" + (this.disabled ? " disabled" : "");
  }

  handleEvent() {
    if (!this.disabled) {
      this.$emit("click");
    }
  }
}
